import React from 'react';
import { Gift, Shuffle, Disc, HelpCircle, Users, Timer } from 'lucide-react';
import { ToolCard } from '../components/ToolCard';
const tools = [{
  title: 'Secret Santa Generator',
  description: 'Organize Secret Santa gift exchanges',
  icon: Gift,
  href: '/fun/secret-santa'
}, {
  title: 'Random Name Picker',
  description: 'Pick random names for giveaways and decisions',
  icon: Shuffle,
  href: '/fun/random-picker'
}, {
  title: 'Wheel of Fortune Spinner',
  description: 'Spin the wheel for random selection',
  icon: Disc,
  href: '/fun/wheel-spinner'
}, {
  title: 'Would You Rather Generator',
  description: 'Generate fun "Would You Rather" questions',
  icon: HelpCircle,
  href: '/fun/would-you-rather'
}, {
  title: 'Team Randomizer',
  description: 'Split people into random teams',
  icon: Users,
  href: '/fun/team-randomizer'
}, {
  title: 'Countdown Timer',
  description: 'Create countdown timers for events',
  icon: Timer,
  href: '/fun/countdown'
}];
export function FunPage() {
  return <div className="container mx-auto px-4 py-8" data-id="element-589">
      <div className="mb-8" data-id="element-590">
        <h1 className="text-4xl font-bold mb-2" data-id="element-591">Fun & Social Tools</h1>
        <p className="text-muted-foreground" data-id="element-592">
          Games, randomizers, and party tools for fun times
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-593">
        {tools.map(tool => <ToolCard key={tool.href} {...tool} data-id="element-594" />)}
      </div>
    </div>;
}